// extracted by mini-css-extract-plugin
module.exports = {"c":"styles_c__1d5Tj","front":"styles_front__1WMl6","back":"styles_back__37HzX","container":"styles_container__13W2K"};